import React, { useState } from "react";
import Header from "../components/header/Header";
import ExposureHeader from "../components/ExposureHeader/ExposureHeader";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import ScrollGames from "../components/ScrollGames/ScrollGames";

function MainLayout() {
  const [eventType, setEventType] = useState(undefined);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <ScrollGames eventType={eventType} setEventType={setEventType} />

      {/* <ExposureHeader /> */}
      <main className=" flex-1 pb-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout;
